// Vue 2 BootstrapVue exposed `this.$bvModal.show(id)` / `.hide(id)` on every
// component. bootstrap-vue-next dropped that global, replacing it with the
// `useModalController()` composable (setup-only). 26 call sites across
// FileMetadata / Report / CustomReport / FileColumnMostCommonValues still use
// the legacy Options-API form. Rewriting all of them to setup() is out of
// scope for the deps-bump MR; install a thin Options-API-friendly shim that
// re-exports `controller.get(id).show()` / `.hide()` as `$bvModal.{show,hide}`.
//
// The plugin must be installed AFTER `createBootstrap()` so the
// modalControllerPlugin injection key is available on the app.
import { useModalController } from 'bootstrap-vue-next';

export default {
  install(app) {
    // `useModalController` calls `inject()`, which only resolves inside an
    // active app context. `runWithContext` wires that up at install time so
    // the controller handle survives outside of any component setup.
    const controller = app.runWithContext(() => useModalController());
    const call = (id, method) => {
      const handle = controller.get(id);
      if (!handle) {
        console.warn(`[bvModalShim] modal id="${id}" not registered`);
        return;
      }
      handle[method]();
    };
    app.config.globalProperties.$bvModal = {
      show: (id) => call(id, 'show'),
      hide: (id) => call(id, 'hide'),
    };
  },
};
